module.exports = __webpack_public_path__ + "img/white.84ae6d42.png";